import { Heading, ListItem } from '@athena/forge';
import ProxyButton from '../common/ProxyButton';
import { ENROLLED_FACTOR_CONFIG } from '../../constants';
import { getLocalizedString } from '../../utils/i18n-utils';

export interface EnrollItemProps {
  oktaFactorItem: JQuery;
  lastItem: boolean;
}

export default function EnrollItem({ oktaFactorItem, lastItem }: Readonly<EnrollItemProps>) {
  const labelElement = oktaFactorItem.find('h3');
  const description = oktaFactorItem.find('p').eq(0);

  const oktaButtonContainer = oktaFactorItem.find('.authenticator-button');

  const dataSe = oktaButtonContainer.data('se') as keyof typeof ENROLLED_FACTOR_CONFIG;
  const { labelI18nKey, descriptionI18nKey } = ENROLLED_FACTOR_CONFIG[dataSe] ?? {};

  const finalLabel = getLocalizedString(labelI18nKey) ?? labelElement.text();
  const finalDescription = descriptionI18nKey ? getLocalizedString(descriptionI18nKey) : description.text();

  const oktaButton = oktaButtonContainer.find('a.button');
  const rowClassName = oktaFactorItem.attr('class') ?? '';
  const iconContainer = oktaFactorItem.find('.authenticator-icon-container');
  const iconContainerClassName = `${iconContainer.attr('class') ?? ''} fe_u_margin--right-medium`.trim();
  const iconClassName = oktaFactorItem.find('.factor-icon').attr('class') ?? '';
  const listItemClassName = `fe_u_flex-container ${lastItem ? 'fe_u_margin--bottom-small' : 'fe_u_margin--bottom-large'}`;

  return (
    <ListItem className={listItemClassName}>
      <div className={rowClassName}>
        <div className={iconContainerClassName}>
          <div className={iconClassName}></div>
        </div>
      </div>
      <div>
        <Heading
          className="fe_u_font-size--default"
          text={finalLabel}
          variant="subsection"
          headingDescription={finalDescription}
        ></Heading>
        <ProxyButton
          oktaButton={oktaButton}
          fullWidth={false}
          size="small"
          variant="secondary"
        />
      </div>
    </ListItem>
  );
}
